import { Leaf, Droplets, Sun, Heart } from "lucide-react";

const items = [
  { icon: Leaf, label: "Herbal alami pilihan" },
  { icon: Droplets, label: "Tanpa pewarna buatan" },
  { icon: Sun, label: "Cocok untuk konsumsi harian" },
  { icon: Heart, label: "Rasa ringan & mudah dinikmati" },
];

const TrustBadges = () => (
  <section
    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4"
    data-testid="trust-badges"
  >
    <div className="bg-white border border-stone-200 rounded-2xl shadow-sm">
      <ul className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-stone-100">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li
              key={it.label}
              className="flex items-center gap-3 px-4 sm:px-6 py-4"
              data-testid={`trust-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="inline-flex w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 items-center justify-center shrink-0">
                <Icon className="w-5 h-5" />
              </span>
              <span className="text-sm sm:text-base font-medium text-stone-800 leading-snug">
                {it.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default TrustBadges;
